import { inject, Injectable } from '@angular/core';

import { CustomerInsights } from '../../model/insights';
import { CdhTwinClient } from './cdh-twin.client';

@Injectable({
  providedIn: 'root',
})
export class CdhTwinService {
  private readonly client = inject(CdhTwinClient);

  async getCustomerInsights(gcid: string): Promise<CustomerInsights | undefined> {
    return (await this.client.getCustomerInsights(gcid)) ?? undefined;
  }
}
